import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import squareCatalogApi from '../../../services/squareCatalogApi';

// Live company-wide needs-review queue. Deliberately NOT module-cached
// (unlike useSquareIntegrated): the count changes with every sync and
// resolve, so each mount fetches fresh. `enabled` must already include
// the integrated signal — when false (non-Square company, missing
// permission, signal not yet checked) this hook performs NO requests.
// Errors — including 404 from an api that predates the endpoint —
// degrade to an empty queue.
const useNeedsReview = (enabled) => {
  const globalCompany = useSelector((state) => state.companyReducer.selected);
  const companyId = globalCompany?.id;
  const [queue, setQueue] = useState({ items: [], count: 0 });
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    if (!enabled || !companyId) {
      setQueue({ items: [], count: 0 });
      setReady(false);
      return;
    }
    try {
      const res = await squareCatalogApi.needsReview(companyId);
      const data = res.data.data;
      setQueue({ items: data?.products || [], count: data?.count || 0 });
    } catch (e) {
      setQueue({ items: [], count: 0 });
    } finally {
      setReady(true);
    }
  }, [enabled, companyId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { items: queue.items, count: queue.count, ready, refresh };
};

export default useNeedsReview;
